export default {
  root: {
    width: '100%',
    padding: ({ padding }) => padding
  }
}
